export const SCORE_OPTIONS = [
  {
    id: 'blank',
    value: 'blank',
    label: 'Blank',
    selected: true,
  },
  {
    id: 0,
    value: 0,
    label: '0',
    selected: true,
  },
  {
    id: 1,
    value: 1,
    label: '1',
    selected: true,
  },
  {
    id: 2,
    value: 2,
    label: '2',
    selected: true,
  },
  {
    id: 3,
    value: 3,
    label: '3',
    selected: true,
  },
];
